module.exports = __webpack_public_path__ + "img/logo-small.1776b96e.svg";